--depricated
<!-- <div class="warp-with-edit">
    <div class="warp-collection" *ngIf="colllection$ | async as collection">
        <div *ngFor="let que of collection;let i = index">
            <que-collection-item [question]="que" [isCollection]="true" (editQuestionEmit)="edit(que)"
                (removeQuestionEmit)="remove($event)"></que-collection-item>
        </div>
    </div>
    <div *ngIf="questionControl.value">
        <div class="btn" (click)="saveEdit()">save edit</div>
        <que-question-form [formControl]="questionControl"></que-question-form>
    </div>
    <div class="btn"> add question to collection???? not realize yet</div>
</div> -->